export default "__VITE_ASSET__EiRsgc_R__"